import { useIntl } from 'react-intl';
import Lottie from 'react-lottie-player/dist/LottiePlayerLight';
import { useLocation } from 'react-router-dom';
import { Stack, Typography } from '@rossum/ui/material';
import * as animationData from './animations/error.json';

type MetabaseAuthErrorLocationState =
  | {
      customMessage?: string;
    }
  | undefined;

const MetabaseAuthError = () => {
  const intl = useIntl();
  const location = useLocation<MetabaseAuthErrorLocationState>();

  return (
    <>
      <Lottie
        loop
        play
        animationData={animationData}
        style={{
          height: '250px',
          width: '250px',
        }}
      />
      <Stack width={380} spacing={2}>
        <Typography variant="h5" color="text.secondary" fontWeight="bold">
          {intl.formatMessage({
            id: 'containers.errorPage.metabase-auth-error.title',
          })}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {location.state?.customMessage ??
            intl.formatMessage({
              id: 'containers.errorPage.metabase-auth-error.text',
            })}
        </Typography>
      </Stack>
    </>
  );
};

export { MetabaseAuthError };
